import { z } from 'zod'
import { statusEnumSchema } from './covianceStatuses'

const stateSchema = z.unknown().nullable()

const displayInfoSchema = z
  .object({
    description: z.string().optional(),
    content: z.record(z.unknown()).optional(),
    subHeading: z.string().optional().nullable(),
    title: z.string().optional().nullable(),
  })
  .optional()
  .nullable()

const decisionLogSchema = z.object({
  attribute1: z.string().nullable(),
  attribute2: z.string().nullable(),
  date_entry: z.coerce.date().nullable(),
  event_order: z.number().nullable(),
  func1: z.unknown().nullable(),
  func2: z.unknown().nullable(),
  group1: z.unknown().nullable(),
  group2: z.unknown().nullable(),
  group_id: z.number().nullable(),
  left_operand: z.string().nullable(),
  operator: z.string().nullable(),
  result: z.string().nullable(),
  right_operand: z.string().nullable(),
  running_decision_id: z.string().nullable(),
  running_expression_id: z.string().nullable(),
  value: z.string().nullable(),
})

const nodeSchema = z.object({
  date_ended: z.coerce.date().nullable(),
  date_started: z.coerce.date().nullable(),
  decision_logs: z.array(decisionLogSchema).nullable(),
  description: z.string(),
  display_info: displayInfoSchema,
  id: z.string(),
  node: z.string(),
  order_id: z.number().positive().int().nullable(),
  status: statusEnumSchema,
})

const workflowStatusSchema = z.object({
  canceled_date: z.coerce.date().nullable().optional(),
  completed_date: z.coerce.date().nullable().optional(),
  description: z.string(),
  estimated_completion: z.string().nullable().optional(),
  id: z.string(),
  input_required: z
    .array(
      z.object({
        attribute: z.string(),
        node_id: z.string(),
      })
    )
    .optional(),
  name: z.string(),
  nodes: z.array(nodeSchema).optional(),
  source_id: z.string().optional(),
  state: stateSchema,
  status: statusEnumSchema.optional(),
  waypoints: z.array(z.unknown()),
})

type WorkflowStatusType = z.infer<typeof workflowStatusSchema>
type NodeType = z.infer<typeof nodeSchema>

const workflowStatusResponseSchema = z.discriminatedUnion('success', [
  z.object({
    message: workflowStatusSchema,
    success: z.literal(true),
  }),
  z.object({
    message: z.string(),
    success: z.literal(false),
  }),
])

export { workflowStatusSchema, workflowStatusResponseSchema, nodeSchema }
export type { WorkflowStatusType, NodeType }
